import { Route, Routes, useLocation } from "react-router-dom";
import routes from "./routes";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom/dist";

const App = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [isIdle, setIsIdle] = useState(false);
  const [timeoutId, setTimeoutId] = useState(false);

  let savorScreenTime = pathname === "/thank-you" ? 15000 : 3600000;

  const reset = useCallback(() => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    setIsIdle(false);
    const id = setTimeout(() => setIsIdle(true), savorScreenTime);
    setTimeoutId(id);
  }, [timeoutId]);

  useEffect(() => {
    window.addEventListener("mousemove", reset);

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      window.removeEventListener("mousemove", reset);
    };
  }, [reset, timeoutId]);

  useEffect(() => {
    if (isIdle && pathname !== "/") navigate("/");
  }, [isIdle, navigate, pathname]);

  useEffect(() => {
    navigate("/");
  }, []);

  return (
    <Routes>
      {routes.map((route, idx) => {
        return (
          route.component && (
            <Route key={idx} path={route.path} element={<route.component />} />
          )
        );
      })}
    </Routes>
  );
};

export default App;
